module.exports = __webpack_public_path__ + "static/media/captain-america.7dcaf87b.jpg";